import { ComponentProps } from "react";
import { ToggleIcon } from "./ToggleIcon";
import { css, useTheme } from "@emotion/react";

export function Bookmark({
  variant = "filled",
  ...props
}: {
  variant?: "filled" | "icon";
} & Omit<ComponentProps<typeof ToggleIcon>, "iconSpec">) {
  const theme = useTheme();

  const { unchecked, checked } = (
    {
      filled: {
        unchecked: {
          enabled: {
            color: "rgba(189, 189, 189, 1)",
            backgroundColor: "white",
            borderRadius: 8,
          },
          hover: {
            color: "rgba(158, 158, 158, 1)",
            backgroundColor: "white",
          },
        },
        checked: {
          enabled: {
            color: theme.palette.subcolor.orange,
            backgroundColor: "white",
            borderRadius: 8,
          },
          hover: {
            color: theme.palette.subcolor.orange,
            backgroundColor: "white",
          },
        },
      },
      icon: {
        unchecked: {
          enabled: {
            color: "rgba(189, 189, 189, 1)",
            backgroundColor: "transparent",
            borderRadius: 8,
          },
          hover: {
            color: "rgba(158, 158, 158, 1)",
            backgroundColor: "transparent",
          },
        },
        checked: {
          enabled: {
            color: theme.palette.subcolor.orange,
            backgroundColor: "transparent",
            borderRadius: 8,
          },
          hover: {
            color: theme.palette.subcolor.orange,
            backgroundColor: "transparent",
          },
        },
      },
    } as const
  )[variant];

  return (
    <ToggleIcon
      iconSpec={{
        unchecked: {
          name: "BookmarkOutlined",
          ...unchecked,
        },
        checked: {
          name: "BookmarkFilled",
          ...checked,
        },
      }}
      {...props}
    />
  );
}
